export const switchData = ({ storage, dispatch, payload }) => {
  switch (storage) {
    case "channels":
      dispatch({ type: "FETCH_CHANNEL", payload });
      break;

    case "channelMember":
      dispatch({ type: "FETCH_CHANNEL_USERS", payload });
      break;

    case "specifiedChannel":
      dispatch({ type: "FETCH_SPECIFIED_CHANNEL", payload });
      break;

    case "posts":
      dispatch({ type: "FETCH_ONE_CHANNEL_POSTS", payload });
      break;

    case "randompost":
      dispatch({ type: "FETCH_RANDOM_POSTS", payload });
      break;

    case "newpost":
      return dispatch({ type: "ADD_NEW_POST", payload });

    case "allchannels":
      return dispatch({ type: "FETCH_ALL_CHANNEL_TO_JOIN", payload });

    case "newchannel":
      return dispatch({ type: "NEW_CHANNEL", payload });

    case "loginUser":
      return dispatch({ type: "LOGIN_USER", payload });

    default:
      break;
  }
};
